/* istanbul ignore file */
/**
 * @deprecated This export is considered deprecated and will be removed in v4.
 * To learn how to migrate visit: https://chameleondesignsystem.com/resources/migrations/core-v3/
 * */
export var Presence;
(function (Presence) {
    Presence["AVAILABLE"] = "available";
    Presence["AWAY"] = "away";
    Presence["BUSY"] = "busy";
    Presence["DND"] = "dnd";
    Presence["DO_NOT_DISTURB"] = "do-not-disturb";
    Presence["OFFLINE"] = "offline";
    Presence["DISCONNECTED"] = "disconnected";
})(Presence || (Presence = {}));
